import assign = require('object-assign');
import { 
    FETCH_REQUEST, FETCH_SUCCESS, FETCH_FAILURE,
    FETCH_NODES_WITH_MEASUREMENTS_REQUEST, FETCH_NODES_WITH_MEASUREMENTS_SUCCESS, FETCH_NODES_WITH_MEASUREMENTS_FAILURE,
    FETCH_NODES_WITH_STATES_REQUEST, FETCH_NODES_WITH_STATES_SUCCESS, FETCH_NODES_WITH_STATES_FAILURE,
} from '../../constants/Node';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch(action.type) {
        case FETCH_REQUEST:
        case FETCH_SUCCESS:
        case FETCH_FAILURE:
        case FETCH_NODES_WITH_STATES_REQUEST:
        case FETCH_NODES_WITH_STATES_SUCCESS:
        case FETCH_NODES_WITH_STATES_FAILURE:
        case FETCH_NODES_WITH_MEASUREMENTS_REQUEST:
        case FETCH_NODES_WITH_MEASUREMENTS_SUCCESS:
        case FETCH_NODES_WITH_MEASUREMENTS_FAILURE:
            return true;
        default:
            return false;
    }
}

export default function nodes(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_NODES_WITH_STATES_REQUEST:
        case FETCH_NODES_WITH_MEASUREMENTS_REQUEST:
        case FETCH_REQUEST: {
            return assign({}, state, {
                nodes: {
                    loading: true
                }
            });
        }
        case FETCH_NODES_WITH_STATES_SUCCESS: 
        case FETCH_NODES_WITH_MEASUREMENTS_SUCCESS: {
            return assign({}, state, {
                nodes: {
                    loading: false,
                    data: action.payload.nodes
                }
            });
        }
        case FETCH_SUCCESS: {
            return assign({}, state, {
                nodes: {
                    loading: false,
                    data: action.payload
                }
            });
        }
        case FETCH_NODES_WITH_STATES_FAILURE:
        case FETCH_NODES_WITH_MEASUREMENTS_FAILURE:
        case FETCH_FAILURE: {
            return assign({}, state, {
                nodes: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/nodes.ts